// library imports
import { useEffect, useState,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PageContent, PageHeader, PageWrapper, PageContainer } from 'components/common/layout_element/LayoutElement';
import * as Constants from "_core/configs/Constants";

// User Component imports
import {Textarea, Row, Button, Stack, Icon, Uploader, Card, Tab, LoadingBox, List, CommonModal, Text} from "_core/components/common/UI";
import { DocsItem, InfoCard } from "components/common/parts";
import { setLoading, setMenuState, setErrorModal, setInitializeState } from "_core/slices/scene/SceneSlice";
import * as SceneConfig from "_core/configs/SceneConfig";
import { FormatDateTime } from "_core/utils/common";

import AdminUserAssetUploadApi from "apis/AdminUserAssetUploadApi";
import AdminUserAssetDeleteApi from "apis/AdminUserAssetDeleteApi";
import AdminUpdateRAGApi from "apis/AdminUpdateRAGApi";
import AdminUpdateUserPromptApi from "apis/AdminUpdateUserPromptApi";

// styles imports
import './AdminUserRagUpload.scss';
import AdminDeleteUserPromptApi from "apis/AdminDeleteUserPromptApi";

const AdminUserRagUpload = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { tUser } = useSelector((store) => store.transaction);
    const { tAccount } = useSelector((store) => store.transaction);
    const { tAssetList } = useSelector((store) => store.transaction);
    const { initializeState } = useSelector((store) => store.scene);

    const [listLoading, setListLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [promptFiles, setPromptFiles] = useState([]);
    const [promptTAsset, setPromptTAsset] = useState(null);

    const [ modalInfo , setModalInfo] = useState( {
        show: false,
        text: '',
        onClick: null,
    });

    const ExecAdminUserAssetUploadApi = AdminUserAssetUploadApi();
    const ExecAdminUserAssetDeleteApi = AdminUserAssetDeleteApi();
    const ExecAdminUpdateRAGApi = AdminUpdateRAGApi();
    const ExecAdminUpdateUserPromptApi = AdminUpdateUserPromptApi();
    const ExecAdminDeleteUserPromptApi = AdminDeleteUserPromptApi();

    // 追加: 許可するファイル拡張子の一覧
    const allowedFileExtensions = [
        ".txt", ".md"
    ];

    // 追加: ファイルが許可された拡張子かチェックするユーティリティ
    const isAllowedFile = (fileObj) => {
        if (!fileObj) return false;
        const name = (fileObj.name || (fileObj.file && fileObj.file.name) || "").toLowerCase();
        return allowedFileExtensions.some(ext => name.endsWith(ext));
    };

    // 許可するプロンプトのファイル拡張子の一覧
    const allowedPromptFileExtensions = [
        ".txt", ".md"
    ];

    // プロンプトのファイルが許可された拡張子かチェックするユーティリティ
    const isAllowedPromptFile = (fileObj) => {
        if (!fileObj) return false;
        const name = (fileObj.name || (fileObj.file && fileObj.file.name) || "").toLowerCase();
        return allowedPromptFileExtensions.some(ext => name.endsWith(ext));
    };

    // アップロード済みアセットデータ
	const [assetDataList, setAssetDataList] = useState({
        columsize: {
            path:5, operation:4
        },
        title: {
            path: "ファイル名",
            operation: "",
        },
		value: []
	});

    useEffect(() => {
        CreateAssetDataList(tAssetList)

        if (!tAssetList || tAssetList.length === 0) {
            return;
        }

        // ユーザープロンプトのアセット情報を取得する
        const promptAsset = tAssetList.find((tAsset) => tAsset.asset_type == Constants.ASSET_TYPE.USER_PROMPT && tAsset.status == 1)
        if (promptAsset !== undefined) {
            setPromptTAsset(promptAsset);
        }
        else {
            setPromptTAsset(null);
        }
    }, [tAssetList]);

    // ダウンロードボタンの処理
    const ExecDownload = (tAsset) => {
    
        const link = document.createElement('a');
        console.log(tAsset.sas);
        console.log(tAsset.path);
        link.href = tAsset.sas;
        // link.download = tAsset.path;
        link.target ="_blank"
        // リンクをクリックしてダウンロードを開始
        link.click();
    };

    function CreateAssetDataList(tAssetList)
    {
        // List用データの生成
		const listData = {
            columsize: {
                path:5, operation:4
            },
            title: {
                path: "ファイル名",
                operation: "",
            },
            value: []
        }

        if (!tAssetList || tAssetList.length === 0)
        {
            setAssetDataList(listData);
            return
        }

        let filteredTAssetList = tAssetList.filter(tAsset => tAsset.asset_type == Constants.ASSET_TYPE.RAG_TEXT && tAsset.status == 1)

		if(filteredTAssetList.length > 0) {		
			filteredTAssetList.forEach((tAsset) => {

				// データの整形
				const assetData = {};
                const title = {};
				// そのまま使えるデータを入れる
                assetData.path = tAsset.path;
                title.path = tAsset.path;

                const ragOperation = (tAsset.add_val !== Constants.RAG_TRAINED_TYPE.NOT_TRAINED) ? Constants.RAG_OPERATION_TYPE.DELETE : Constants.RAG_OPERATION_TYPE.ADD;
                const ragOperationLabel = (tAsset.add_val !== Constants.RAG_TRAINED_TYPE.NOT_TRAINED) ? "解除" : "学習";
                const ragOperationClass = (tAsset.add_val !== Constants.RAG_TRAINED_TYPE.NOT_TRAINED) ? " " : "primary ";
                assetData.operation = (
                    <Row className="spacing-8px">
                        <Button className={"operate-button secondary-border " + ragOperationClass} onClick={() => {ExecRAGUpdate(tAsset.id, ragOperation)}}><Row className="text-size-normal text-normal-weight operate-label">{ragOperationLabel}</Row></Button>
                        <Button className={"operate-button secondary-border success"} onClick={() => {ExecDownload(tAsset)}}><Row className="text-size-normal text-normal-weight operate-label">ダウンロード</Row></Button>
                        <Button className={"operate-button secondary-border danger"} onClick={() => {ExecDelete(tAsset.id)}}><Row className="text-size-normal text-normal-weight operate-label">削除</Row></Button>
                    </Row>
                );

				// 各データのクリック時処理
				const onClick = () => {
				};

				// リスト用データの作成
				listData.value.push({
					data: assetData,
					title: title,
					onclick: onClick
				});
			});
		}

		setAssetDataList(listData);
    }

    useEffect(() => {
        dispatch(setMenuState({ isHeader: false, isMenu: true, isFooter: false, isFullScreen: false }));
    }, [dispatch]);
    
    useEffect(() => {
        if(initializeState !== Constants.INITIALIZE_STATE.allComplete)
        {
            return;
        }

        // 現在の設定で初期表示設定を行う
        dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete));

    }, [initializeState]);

    const AdminAssetsUploadApiRequest = async (asset_type, file, file_name) => {
        // アセットアップロードAPI
        
        // 通信中の表示を出す
        dispatch(setLoading(true));

        const result = await ExecAdminUserAssetUploadApi(asset_type, file, file_name);
        // 通信中の表示を消す
        dispatch(setLoading(false));
        if (result.error || (result.response && result.response.error_code > 0))
        {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else
        {
            setFiles([]);
        }
    };

    const ExecAssetsUploadAsync = () => {ExecAssetsUpload()}
    const ExecAssetsUpload = async () => {
        setListLoading(true);
        if (!files || files.length === 0) {
            setListLoading(false);
            return;
        }
        // Uploader の構造によっては files[0].file か files[0] のどちらかになるため両方を考慮
        const selectedFile = files[0].file || files[0];
        // 拡張子チェック
        if (!isAllowedFile(selectedFile)) {
            setListLoading(false);
            dispatch(setErrorModal({
                show: true,
                text: {
                    code: 'サポートされていないファイル形式',
                    message: 'サポートされていないファイル形式です。許可されている形式: ' + allowedFileExtensions.join(', ')
                }
            }));
            return;
        }

        const page = await AdminAssetsUploadApiRequest(Constants.ASSET_TYPE.RAG_TEXT, selectedFile, selectedFile.name)
 
         setListLoading(false);
     }

    const ExecAdminUserAssetDeleteApiRequest = async (tid, asset_type) => {
        // アセット削除API
        setListLoading(true);

        // 通信中の表示を出す
        dispatch(setLoading(true));

        const result = await ExecAdminUserAssetDeleteApi(tid, asset_type);

        // 通信中の表示を消す
        dispatch(setLoading(false));

        if (result.error || (result.response && result.response.error_code > 0)) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }

        setListLoading(false);
    };

    // 削除ボタンの処理
    const ExecDelete = (id) => {
        setModalInfo({ show: true, title: "RAGファイル削除", text: "削除したファイルは元に戻すことはできません。</br>削除してもよろしいですか？", onclick: () => {
            ExecAdminUserAssetDeleteApiRequest(id, Constants.ASSET_TYPE.RAG_TEXT)
        }});
    };


    const ExecAdminUpdateRAGApiRequest = async (t_asset_id, operation, use_fixed_chunk) => {
        // アセット削除API
        setListLoading(true);

        // 通信中の表示を出す
        dispatch(setLoading(true));

        const result = await ExecAdminUpdateRAGApi(t_asset_id, operation, use_fixed_chunk);

        // 通信中の表示を消す
        dispatch(setLoading(false));

        if (result.error || (result.response && result.response.error_code > 0)) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }

        setListLoading(false);
    };

    // 削除ボタンの処理
    const ExecRAGUpdate = (id, operation) => {
        // RAG_OPERATION_TYPE.ADDの場合は確認ダイアログを表示
        if (operation === Constants.RAG_OPERATION_TYPE.ADD) {
            setModalInfo({
                show: true,
                title: "学習確認",
                text: (
                    <div className="rag-update-modal-content">
                        <div>固定チャンク分割しますか？</div>
                        <div className="chunk-option-container">
                            <div className="chunk-option-item">　はい：{tUser.config.chunk_size}文字以内で分割します。</div>
                            <div className="chunk-option-item">いいえ：{tUser.config.chunk_size}文字付近で分割します。</div>
                        </div>
                        <div className="note-text margin-top-8px">※キャンセルする場合はポップアップの外をクリックしてください。</div>
                        <div className="note-text margin-top-8px">※文字数が多い場合、完了まで時間がかかることがあります。</div>
                    </div>
                ),
                confirmvalue: "はい",
                cancelvalue: "いいえ",
                onclick: () => { ExecAdminUpdateRAGApiRequest(id, operation, true); },
                oncancel: () => { ExecAdminUpdateRAGApiRequest(id, operation, false); }
            });
        } else {
            // DELETE 等はそのまま実行（use_fixed_chunk は false を渡す）
            ExecAdminUpdateRAGApiRequest(id, operation, false);
        }
    };

    const ExecAdminUpdateUserPromptApiRequest = async (promptFile) => {
        // 通信中の表示を出す
        dispatch(setLoading(true));

        const deleteTAssetId = promptTAsset !== null ? promptTAsset.id : 0;
        const result = await ExecAdminUpdateUserPromptApi(promptFile, deleteTAssetId);

        // 通信中の表示を消す
        dispatch(setLoading(false));

        if (result.error || (result.response && result.response.error_code > 0)) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else {
            setPromptFiles([]);
        }
    };

    const ExecUpdateUserPrompt = async () => {
        setListLoading(true);

        // プロンプトのファイルの指定が無い場合はスキップ
        if (!promptFiles || promptFiles.length === 0) {
            setListLoading(false);
            return;
        }

        // Uploader の構造によっては promptFiles[0].file か promptFiles[0] のどちらかになるため両方を考慮
        const selectedFile = promptFiles[0].file || promptFiles[0];
        // 拡張子チェック
        if (!isAllowedPromptFile(selectedFile)) {
            setListLoading(false);
            dispatch(setErrorModal({
                show: true,
                text: {
                    code: 'サポートされていないファイル形式',
                    message: 'サポートされていないファイル形式です。許可されている形式: ' + allowedPromptFileExtensions.join(', ')
                }
            }));
            return;
        }

        await ExecAdminUpdateUserPromptApiRequest(selectedFile);

        setListLoading(false);
    };

    const ExecAdminDeleteUserPromptApiRequest = async () => {
        // 通信中の表示を出す
        dispatch(setLoading(true));

        const result = await ExecAdminDeleteUserPromptApi(promptTAsset.id);

        // 通信中の表示を消す
        dispatch(setLoading(false));

        if (result.error || (result.response && result.response.error_code > 0)) {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else {
            setPromptFiles([]);
        }
    };

    const ExecDeleteUserPrompt = async () => {
        setModalInfo({
            show: true,
            title: "追加参照ファイル削除",
            text: "削除したファイルは元に戻すことはできません。</br>削除してもよろしいですか？",
            onclick: async () => {
                setListLoading(true);

                await ExecAdminDeleteUserPromptApiRequest();

                setListLoading(false);
            }
        });
    };

    return (
    <PageContent pageId="AdminUserRagUpload">
            <PageHeader>
                <Stack className="spacing-4px">
                    <div className="page-header-title">RAGファイル管理</div>
                    <div className="page-header-detail">{Constants.AI_NAME}が参照するRAG情報を登録/更新します。</div>
                </Stack>
            </PageHeader>
            <PageWrapper>
                <PageContainer>
                    {/* ここにページ内コンテンツのコンポーネントを記述 */}
                    <Stack className="block-center spacing-32px">
                        {/* RAGファイル */}
                        <Card className="base-card">
                            <Stack className="flex-center spacing-32px align-center width-full">
                                <Stack className= "list-area align-center spacing-16px width-full">
                                    <List
                                        list={assetDataList}
                                        header={true}
                                        scrollbar={"scrollbar"}
                                        className="width-full"
                                        isLoading={((initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) || listLoading ) ? true : false}
                                        loadingCount={2}
                                    />
                                    {(assetDataList && assetDataList.value && assetDataList.value.length === 0) && (
                                        <Stack className="flex-center align-center width-full">
                                            <Text className="text-color-weak">ファイルがアップロードされていません</Text>
                                        </Stack>
                                    )}
                                </Stack>
                                <Stack className= "align-center spacing-16px width-full">
                                    <Stack className="flex-center align-center spacing-16px width-full">
                                        <Uploader
                                            className="custom-uploader"
                                            accept={allowedFileExtensions}
                                            onFileChanged={(files) => {
                                                console.log(files);
                                                setFiles(files)
                                            }}
                                            files={files}
                                            isSwap={true}
                                            minimum={false}
                                        />
                                        <InfoCard className="input-form-area">
                                                <div>アップロードされた情報は{Constants.AI_NAME}が返答のために参照します。</div>
                                                <div>非公開情報がファイルに含まれないか事前に確認を行って下さい。</div>
                                                <div className="text-color-weak">対応形式: {allowedFileExtensions.join(', ')}</div>
                                        </InfoCard>
                                    </Stack>
                                    <Stack className="align-center">
                                        <Button className={"width-320px " + ((files && files.length > 0) ? "primary" : "primary disabled")} onClick={() => {ExecAssetsUploadAsync()}}>
                                            {listLoading ? 
                                                <Stack className="flex-center align-center">
                                                    <LoadingBox></LoadingBox>
                                                </Stack>
                                                :
                                                <Row className="flex-center spacing-8px width-full">
                                                    <Icon className="label-icon" icon="plus" size={24} />
                                                    <div>アップロード</div>
                                                </Row>
                                            }
                                        </Button>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Card>
                        {/* ユーザープロンプト */}
                        {
                            (tUser !== null) &&
                            <Card className="base-card">
                                <Stack className="spacing-32px align-center">
                                    <Row className="flex-both align-center spacing-16px width-full">
                                        <Stack className="stack flex-center spacing-4px">
                                            <Text className="input-label input-label-text text-size-medium text-bold">追加参照ファイル</Text>
                                            <Text className="input-label input-label-text text-size-small">{Constants.AI_NAME}が全ての返答のために参照します。</Text>
                                        </Stack>
                                    </Row>
                                    <Stack className="align-center width-full spacing-16px input-prompt-area">
                                        {
                                            promptTAsset &&
                                            <Card className="border-card file-display-area width-full">
                                                <Row className="flex-both align-center spacing-8px width-full">
                                                    <Stack className="flex-center align-center">
                                                        {promptTAsset.path}
                                                    </Stack>
                                                    <Row className="operate-area flex-right spacing-8px align-center">
                                                        <Text className="flex-right width-full token-count">{`${promptTAsset.add_val}/${tUser.config.user_prompt_max_token}トークン`}</Text>
                                                        <Row className="flex-center align-center spacing-8px width-full">
                                                            <Icon className="time-icon text-color-weak" icon="arrow-clockwise" size={24} />
                                                            <Text>{FormatDateTime(promptTAsset.regdate)}</Text>
                                                        </Row>
                                                        <Button
                                                            className="operate-button secondary-border success"
                                                            onClick={() => {
                                                                ExecDownload(promptTAsset);
                                                            }}
                                                        >
                                                            <Row className="text-size-normal text-normal-weight operate-label width-fit">
                                                                ダウンロード
                                                            </Row>
                                                        </Button>
                                                        <Button
                                                            className="operate-button secondary-border danger"
                                                            onClick={() => {
                                                                ExecDeleteUserPrompt();
                                                            }}
                                                        >
                                                            <Row className="text-size-normal text-normal-weight operate-label width-fit">
                                                                削除
                                                            </Row>
                                                        </Button>
                                                    </Row>
                                                </Row>
                                            </Card>
                                        }
                                        <Uploader
                                            className="custom-uploader"
                                            accept={[".txt"]}
                                            onFileChanged={(files) => {
                                                setPromptFiles(files)
                                            }}
                                            files={promptFiles}
                                            isSwap={true}
                                            minimum={false}
                                        />
                                        {
                                            promptTAsset &&
                                            <InfoCard className=" width-full input-form-area">
                                                <div>ファイル更新時、古いファイルは削除されます。</div>
                                            </InfoCard>
                                        }
                                        <Stack className="align-center">
                                            <Button
                                                className={"width-320px primary" + (promptFiles.length > 0 ? "" : " disabled")}
                                                onClick={() => {
                                                    if (promptTAsset)
                                                    {
                                                        setModalInfo({ show: true, title: "確認", text: "ファイルをアップロードすると古いファイルは削除されます。<br>更新してよろしいですか？", onclick: () => {
                                                            ExecUpdateUserPrompt();
                                                        }});
                                                    }
                                                    else {
                                                        ExecUpdateUserPrompt();
                                                    }
                                                }}
                                            >
                                                {listLoading ?
                                                    <Stack className="flex-center align-center">
                                                        <LoadingBox></LoadingBox>
                                                    </Stack>
                                                    :
                                                    <Row className="flex-center spacing-8px width-full">
                                                        <Icon className="label-icon" icon="plus" size={24} />
                                                        <div>アップロード</div>
                                                    </Row>
                                                }
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </Card>
                        }
                    </Stack>
                </PageContainer>
                <CommonModal modalInfo={modalInfo} setModalInfo={setModalInfo}></CommonModal>
            </PageWrapper>
    </PageContent>
    );
};

export default AdminUserRagUpload;